// import Vue from 'vue';
// import Vuex from 'vuex';
import app from '$$app';
import { createStore as _createStore } from 'vuex';
import ResourcesStore from './resources';
import RolesStore from './roles';
import TasksStore from './tasks';
// import PaymentStore from './payment';
import router from '../router/main';
import GlobalPopup from '../views/common/VueComponents/popups/globalPopup/globalPopupStore';
import PassStrength from '../views/common/VueComponents/popups/passStrengthPopup/passStrengthStore';
import HeaderStore from '../views/header/headerStore';
import ProfileSettingsStore from '../views/profileSettings/profileSettingsStore';

import constants from '$$helpers/constants';
import routerHelper from '$$helpers/router';
import multiViewsProjectsModel from '$$multiviewModel';
import projectsModel from '$$projectModel';
import pricingHelper from '../helpers/pricingHelper';
//import filterStoreOld from '../views/filterOld/filterStore';
import FooterStore from '../views/footer/footerStore';
import onboardingStore from '../views/onboarding/onboardingStore';
import PaymentClientStore from '../views/paymentPlans/paymentClientStore';
import TooltipStore from '../views/tooltip/tooltipStore';
import GalleryStore from '../views/vueGallery/storeGallery';
import AttachmentsStore from './attachments';
import BaselinesStore from './baselines/index';
import BoardStore from './board';
import columnsStore from './columns/index';
import CommentsStore from './comments';
import CopyPasteSettingsStore from './copyPaste/index';
import filterStore from './filter/index';
import HistoryStore from './history';
import IntegrationGoogleStore from './integrations/integrationGoogle';
import IntegrationOutlookStore from './integrations/integrationOutlook';
import MassChangeStore from './massChange';
import progressBarStore from './progressBar/index';
import TeamStore from './teamStore';
import TestStore from './test';
import UserStore from './user';
import userNotificationStore from './userNotification';

// Vue.use(Vuex);

const store = _createStore({
  namespaced: true,
  modules: {
    tasksModel: TasksStore,
    resourcesModel: ResourcesStore,
    roles: RolesStore,
    // paymentModel: PaymentStore,
    // filterOld: filterStoreOld,
    filter: filterStore,
    profileSettings: ProfileSettingsStore,
    globalPopup: GlobalPopup,
    passStrengthPopup: PassStrength,
    headerView: HeaderStore,
    footer: FooterStore,
    tooltip: TooltipStore,
    paymentClient: PaymentClientStore,
    teamSetting: TeamStore,
    user: UserStore,
    onboarding: onboardingStore,
    comments: CommentsStore,
    attachments: AttachmentsStore,
    copyPaste: CopyPasteSettingsStore,
    columns: columnsStore,
    progress: progressBarStore,
    baselines: BaselinesStore,
    massChange: MassChangeStore,
    userNotification: userNotificationStore,
    integrationGoogle: IntegrationGoogleStore,
    integrationOutlook: IntegrationOutlookStore,
    board: BoardStore,
    history: HistoryStore,
    gallery: GalleryStore,
    test: TestStore,
  },
  state: {
    windowParams: {},
    leftSidebarWidth: 0,
    headerHeight: 0,
    appMode: constants.APP_MODES.BASE,
    contentParams: {},
    blockSideBar: false,
    globalToast: false,
    ganttInProgress: false,
    isColumnsSidebarHasConfirmation: false,
    showGrid: true,
  },
  getters: {
    getWindowParams: (state, getters) => {
      const accessToFeatures = {
        workload: pricingHelper.checkPricingAccess('workload'),
      };
      const route = router.currentRoute.value;

      let params;
      const leftSidebarWidth = getters.leftSidebarWidth;
      const headerHeight = getters['headerView/height'];
      // const isGanttVisible = route.path.includes('gantt');
      const isGlobalWorkloadRoute = route.name === 'workload';
      // const isTaskInGlobalWorkload = route.name === 'workloadTaskRoute';
      // const isProjectWorkloadRoute = (route.name === 'project'
      // || route.name === 'projectsMultiView'
      // || route.name === 'taskRoute')
      // && route.params.mode === 'workload';
      // const isTaskVisible = route.path.includes('task/');
      const isProfileSettingsPage = route.path.includes('settings');
      const isReportsPage = route.path.includes('reports');
      const isExportPage = route.path.includes('export');
      const isHistoryPage = route.path.includes('history');
      const isCommentRoute = route.name === 'commentsRoute';
      const isAttachmentsRoute = route.name === 'attachmentsRoute';
      const isImportPreview = route.path.includes('importpreview');
      // const isListTask = route.path.includes('list/task');
      const leftDelta = 0;
      const height = document.body.clientHeight - headerHeight;
      // const reuqiredDynamicDataLoaded = getters.reuqiredDynamicDataLoaded;

      // if (isTaskVisible && isGanttVisible) {
      //   const taskNameNode = document.querySelector(`[data-column-id="${constants.GANTT_BASE_COLUMNS.TASK_NAME}"]`);
      //
      //   leftDelta = taskNameNode ? (taskNameNode.offsetLeft + taskNameNode.offsetWidth) : 0;
      // }

      // leftDelta = isListTask ? 0 : leftDelta;

      params = {
        height,
        width: document.body.clientWidth - leftSidebarWidth - leftDelta,
        left: leftSidebarWidth + leftDelta,
        top: headerHeight + 1,
        zIndex: 9,
        visibility: 'visible',
      };

      // if (isTaskInGlobalWorkload && reuqiredDynamicDataLoaded) {
      //   params = { visibility: 'hidden' };
      // }

      // if ((isGanttVisible || (isProjectWorkloadRoute && accessToFeatures.workload)) /* && !isTaskVisible */) {
      //   params = { visibility: 'hidden' };
      // }

      if (isGlobalWorkloadRoute && accessToFeatures.workload) {
        params = {
          height,
          width: document.body.clientWidth - leftSidebarWidth,
          left: leftSidebarWidth,
          top: headerHeight + 1,
          zIndex: 9,
          visibility: 'visible',
        };

        const result = { ...params, ...state.windowParams };

        Object.keys(result).forEach(key => {
          if (['left', 'top', 'height', 'width'].includes(key)) {
            if (typeof result[key] === 'number') {
              result[key] += 'px';
            }
          }
        });

        return result;
      }

      if (isExportPage || isHistoryPage) {
        params = {
          height: document.body.clientHeight,
          width: document.body.clientWidth,
          top: 0,
          left: 0,
          visibility: 'visible',
        };
      }

      // TODO should remove when comments and attachments will in pages
      if (isCommentRoute || isAttachmentsRoute || app.config.mode.isLink) {
        params = {
          height: 0,
          width: 0,
          top: 0,
          left: 0,
          zIndex: 1000,
          visibility: 'visible',
        };
      }

      if (isProfileSettingsPage) {
        params.height = '100vh';
      }
      
      if (isReportsPage) {
       delete params.height;
      }

      if (app.config.mode.isExport) {
        params.pointerEvents = 'none';
        params.height = document.body.clientHeight;
        params.background = 'none';
      }

      if (isImportPreview) {
        params.zIndex = 1000;
      }

      const result = { ...state.windowParams, ...params };

      Object.keys(result).forEach(key => {
        if (['left', 'top', 'height', 'width'].includes(key)) {
          if (typeof result[key] === 'number') {
            result[key] += 'px';
          }
        }
      });

      return result;
    },
    contentParams: (state, getters) => state.contentParams,
    leftSidebarWidth: state => state.leftSidebarWidth,
    headerHeight: state => state.headerHeight,
    blockSideBar: state => state.blockSideBar,
    reuqiredDynamicDataLoaded: (state, getters) => {
      const customFieldsValuesLoaded = getters['columns/valuesLoaded'];

      return customFieldsValuesLoaded;
    },
    isBase: state => state.appMode === constants.APP_MODES.BASE,
    isExport: state => state.appMode === constants.APP_MODES.EXPORT,
    isLink: state => state.appMode === constants.APP_MODES.PUBLIC_LINK,
    isHistory: state => state.appMode === constants.APP_MODES.HISTORY,
    isColumnsSidebarHasConfirmation: state => state.isColumnsSidebarHasConfirmation,
    getActiveGanttIdsByRoute: () => {
      const currentRoute = routerHelper.getCurrentRoute();
      let ganttIds = [];

      if (routerHelper.isListViewRoute()) {
        ganttIds = projectsModel.getAllProjects().map(p => p.gantt_id);
      }

      if (currentRoute.path.includes('projects/')) {
        ganttIds = multiViewsProjectsModel.getActiveViewData().ganttIDs;
      }

      if (currentRoute.path.includes('project/')) {
        ganttIds = [+routerHelper.getCurrentRoute().params.projectId];
      }

      return ganttIds.filter(ganttId => !projectsModel.isArchived(ganttId));
    },
    getShowGrid: state => state.showGrid,
  },
  mutations: {
    setGanttInProgress(state, flag) {
      state.ganttInProgress = flag;
    },
    setWindowParams(state, payload) {
      state.windowParams = { ...state.windowParams, ...payload };
    },
    setLeftSidebarWidth(state, width) {
      state.leftSidebarWidth = width;
    },
    setHeaderHeight(state, height) {
      state.headerHeight = height;
    },
    setAppMode(state, payload) {
      state.appMode = payload;
    },
    updateContentParams(state) {
      const headerHeight = this.getters['headerView/height'];
      const params = {
        top: headerHeight + 1,
        bottom: 0,
        width: document.body.clientWidth - this.getters.leftSidebarWidth,
        height: document.body.clientHeight - headerHeight,
        left: this.getters.leftSidebarWidth,
        visibility: 'visible',
      };

      if (app.config.mode.isExport) {
        params.height = document.body.clientHeight;
        params.left = 0;
      }
      if (app.config.mode.isLink) {
        params.height = document.body.clientHeight - headerHeight;
        params.left = 0;
      }

      state.contentParams = params;
    },
    setBlockedSideBar(state, flag) {
      state.blockSideBar = flag;
    },
    setColumnsSidebarConfirmationStatus(state, flag) {
      state.isColumnsSidebarHasConfirmation = flag;
    },
    setShowGrid(state, flag) {
      state.showGrid = flag;
    },
  },
  actions: {
    updateWindowParams({ commit }, payload) {
      commit('setWindowParams', payload);
      commit('updateContentParams');
    },
  },
});

store.subscribe((mutation, state) => {
  if (mutation.type.includes('resourcesModel')) {
    app.trigger('resources:model:afterMutation', mutation);
  }
});

app.on('app:start', () => {
  if (app.config.mode.isBase) {
    store.commit('setAppMode', constants.APP_MODES.BASE);
  } else if (app.config.mode.isHistory) {
    store.commit('setAppMode', constants.APP_MODES.HISTORY);
  } else if (app.config.mode.isLink) {
    store.commit('setAppMode', constants.APP_MODES.PUBLIC_LINK);
  } else if (app.config.mode.isExport) {
    store.commit('setAppMode', constants.APP_MODES.EXPORT);
  }
  store.dispatch('roles/loadData');
  store.dispatch('tasksModel/loadData');
  store.dispatch('resourcesModel/loadData');
  store.dispatch('teamSetting/init');
  store.dispatch('user/getActivities');
  store.dispatch('columns/loadData');
  store.dispatch('userNotification/loadUserSettingsDataNotification');
  if (!app.config.mode.isLink) {
    store.dispatch('integrationGoogle/loadData');
    store.dispatch('integrationOutlook/loadData');
  }

  store.dispatch('filter/loadData');
  // store.dispatch('teamSetting/checkIntegrationReconnect');
});

// hack for migration from webix to vuex models
// use only if there is no other choice!!!
app.callGlobalStore = function (type, name, params) {
  if (type === 'getter') {
    return params ? store.getters[name](...params) : store.getters[name];
  }

  if (type === 'action') {
    return store.dispatch(name, ...params);
  }
};

export default store;
